// import { Box, Heading, HStack, Text } from "@chakra-ui/react";
// import React, { useMemo, useState,useEffect } from "react";
// import { PRODUCTS_TABS } from "../../constants/ui";
// import CategorySizeIcon from "../../components/Icons/CategorySizeIcon";
// import InsightsResearchIcon from "../../components/Icons/InsightsResearchIcon";
// import SMEActivityIcon from "../../components/Icons/SMEActivityIcon";
// import FindSuppliersIcon from "../../components/Icons/FindSuppliersIcon";
// import { useSelector,useDispatch } from "react-redux";
// import { getSectorCategories, getAllSectors } from "../../actions/sector/sectorActions";

// // const DEFAULT_SECTOR = {
// //   _id: "67c59f894605e819d8fb86ca",
// //   sectorName: "Food and Kindred Products",
// //   sectorCode: 20,
// // };

// const SectorLinks = ({ currentTab, changeTab }) => {
//   const sectors = [
//     { id: "67c59f894605e819d8fb86af", name: "Textile Mill Products" },
//     { id: "67c59f894605e819d8fb86ca", name: "Food Kindred Products" },
//     { id: "67c59f894605e819d8fb86c0", name: "Apparel Finished Products" },
//     { id: "67c59f894605e819d8fb86c3", name: "Primary Metals Industry" },
//     // ... others
//   ];
//   const { isAuthenticatedUser } = useSelector((s) => s.userReducer || {});
//   return (
//     <HStack>
//       <Box m="0px" w="100%">
//         <Text
//           className={currentTab === PRODUCTS_TABS.CATEGORY_SIZE ? "productSubTabs productSubTabs-selected" : "productSubTabs"}
//           style={{ display: "flex", width: "122px" }}
//           onClick={() => changeTab(PRODUCTS_TABS.CATEGORY_SIZE)}
//         >
//           <Box mr="5px">
//             <CategorySizeIcon color={currentTab === PRODUCTS_TABS.CATEGORY_SIZE ? "#FFFFFF" : "#5D5D5D"} />
//           </Box>
//           <Box>Category Size</Box>
//         </Text>
//       </Box>

//       {!isAuthenticatedUser && (
//         <Box m="0px" w="100%">
//           <Text
//             className={currentTab === PRODUCTS_TABS.COMPETITIVE_RISK ? "productSubTabs productSubTabs-selected" : "productSubTabs"}
//             style={{ display: "flex", width: "145px" }}
//             onClick={() => changeTab(PRODUCTS_TABS.COMPETITIVE_RISK)}
//           >
//             <Box mr="5px">
//               <InsightsResearchIcon color={currentTab === PRODUCTS_TABS.COMPETITIVE_RISK ? "#FFFFFF" : "#5D5D5D"} />
//             </Box>
//             <Box>Competitive Risk</Box>
//           </Text>
//         </Box>
//       )}

//       <Box m="0px" w="100%">
//         <Text
//           className={currentTab === PRODUCTS_TABS.SME_ACTIVITY ? "productSubTabs productSubTabs-selected" : "productSubTabs"}
//           style={{ display: "flex", width: "122px" }}
//           onClick={() => changeTab(PRODUCTS_TABS.SME_ACTIVITY)}
//         >
//           <Box mr="5px">
//             <SMEActivityIcon color={currentTab === PRODUCTS_TABS.SME_ACTIVITY ? "#FFFFFF" : "#5D5D5D"} />
//           </Box>
//           <Box>SME Activity</Box>
//         </Text>
//       </Box>

//       <Box m="0px" w="100%">
//         <Text
//           className={currentTab === PRODUCTS_TABS.FIND_SUPPLIERS ? "productSubTabs productSubTabs-selected" : "productSubTabs"}
//           style={{ display: "flex", width: "122px" }}
//           onClick={() => changeTab(PRODUCTS_TABS.FIND_SUPPLIERS)}
//         >
//           <Box mr="5px">
//             <FindSuppliersIcon color={currentTab === PRODUCTS_TABS.FIND_SUPPLIERS ? "#FFFFFF" : "#5D5D5D"} />
//           </Box>
//           <Box>Find Suppliers</Box>
//         </Text>
//       </Box>
//     </HStack>
//   );
// };

// const getSectorName = (s) =>
//   s?.sectorName ||
//   s?.linkedSIC2?.name ||
//   s?.sic2?.name ||
//   s?.name ||
//   null;


// const HeaderSectors = ({ currentTab, changeTab, selectedSectorData }) => {
//  const { categories = [], categoriesLoading = false, data = [], loading = false, loaded = false } =
//     useSelector((s) => s.sectorSmmReducer);
//   const sectors = Array.isArray(data) ? data : [];
//    const dispatch = useDispatch();

//   console.log("HeaderSectors - selectedSectorData:", selectedSectorData); // Debug log
//   console.log("HeaderSectors - sectors from reducer:", data); // Debug log


//   useEffect(() => {
//     if (!categoriesLoading && categories.length === 0) {
//       dispatch(getSectorCategories());
//     }
//   }, [dispatch, categoriesLoading, categories.length]);

//   // Get the display name based on selected sector data or fallback
//   const displayName = useMemo(() => {
//     // If we have selected sector data from icon click, use that
//     if (selectedSectorData) {
//       const nameFromSelected = getSectorName(selectedSectorData);
//       if (nameFromSelected) {
//         console.log("Using selected sector name:", nameFromSelected); // Debug log
//         return nameFromSelected;
//       }
//     }
    
//     // Fallback to first sector from reducer data
//     if (sectors.length > 0) {
//       const firstSectorName = getSectorName(sectors[0]);
//       console.log("Using first sector name:", firstSectorName); // Debug log
//       return firstSectorName || "Sector";
//     }
    
//     console.log("Using default sector name"); // Debug log
//     // return DEFAULT_SECTOR.sectorName || "Sector";
//   }, [sectors, selectedSectorData]);

//   return (
//     <HStack style={{ padding: "5px 10px" }} justifyContent={"space-between"}>
//       <Box>
//         <Heading
//           fontSize="var(--sylvr-h3-fs)"
//           fontWeight="var(--sylvr-h3-fw)"
//           color="var(--sylvr-text-color)"
//           pr={3}
//         >
//           {displayName}
//         </Heading>
//         {/* Optional: Show category name as subtitle */}
//         {selectedSectorData && selectedSectorData.categoryName && (
//           <Text fontSize="sm" color="gray.600" fontStyle="italic">
//             {selectedSectorData.categoryName}
//           </Text>
//         )}
//         {loading && <Text fontSize="xs" color="gray.500">Refreshing sectors…</Text>}
        
        
//       </Box>

//       <HStack>
//         <SectorLinks currentTab={currentTab} changeTab={changeTab} />
//       </HStack>
//     </HStack>
//   );
// };

// export default HeaderSectors;

// import { Box, Heading, HStack, Text } from "@chakra-ui/react";
// import React, { useMemo, useEffect } from "react";
// import { PRODUCTS_TABS } from "../../constants/ui";
// import CategorySizeIcon from "../../components/Icons/CategorySizeIcon";
// import InsightsResearchIcon from "../../components/Icons/InsightsResearchIcon";
// import SMEActivityIcon from "../../components/Icons/SMEActivityIcon";
// import FindSuppliersIcon from "../../components/Icons/FindSuppliersIcon";
// import { useSelector, useDispatch } from "react-redux";
// import { getSectorCategories, getAllSectors } from "../../actions/sector/sectorActions";

// const SectorLinks = ({ currentTab, changeTab }) => {
//   const { isAuthenticatedUser } = useSelector((s) => s.userReducer || {});
//   return (
//     <HStack>
//       <Box m="0px" w="100%">
//         <Text
//           className={
//             currentTab === PRODUCTS_TABS.CATEGORY_SIZE
//               ? "productSubTabs productSubTabs-selected"
//               : "productSubTabs"
//           }
//           style={{ display: "flex", width: "122px" }}
//           onClick={() => changeTab(PRODUCTS_TABS.CATEGORY_SIZE)}
//         >
//           <Box mr="5px">
//             <CategorySizeIcon
//               color={currentTab === PRODUCTS_TABS.CATEGORY_SIZE ? "#FFFFFF" : "#5D5D5D"}
//             />
//           </Box>
//           <Box>Category Size</Box>
//         </Text>
//       </Box>

//       {!isAuthenticatedUser && (
//         <Box m="0px" w="100%">
//           <Text
//             className={
//               currentTab === PRODUCTS_TABS.COMPETITIVE_RISK
//                 ? "productSubTabs productSubTabs-selected"
//                 : "productSubTabs"
//             }
//             style={{ display: "flex", width: "145px" }}
//             onClick={() => changeTab(PRODUCTS_TABS.COMPETITIVE_RISK)}
//           >
//             <Box mr="5px">
//               <InsightsResearchIcon
//                 color={currentTab === PRODUCTS_TABS.COMPETITIVE_RISK ? "#FFFFFF" : "#5D5D5D"}
//               />
//             </Box>
//             <Box>Competitive Risk</Box>
//           </Text>
//         </Box>
//       )}

//       <Box m="0px" w="100%">
//         <Text
//           className={
//             currentTab === PRODUCTS_TABS.SME_ACTIVITY
//               ? "productSubTabs productSubTabs-selected"
//               : "productSubTabs"
//           }
//           style={{ display: "flex", width: "122px" }}
//           onClick={() => changeTab(PRODUCTS_TABS.SME_ACTIVITY)}
//         >
//           <Box mr="5px">
//             <SMEActivityIcon
//               color={currentTab === PRODUCTS_TABS.SME_ACTIVITY ? "#FFFFFF" : "#5D5D5D"}
//             />
//           </Box>
//           <Box>SME Activity</Box>
//         </Text>
//       </Box>

//       <Box m="0px" w="100%">
//         <Text
//           className={
//             currentTab === PRODUCTS_TABS.FIND_SUPPLIERS
//               ? "productSubTabs productSubTabs-selected"
//               : "productSubTabs"
//           }
//           style={{ display: "flex", width: "122px" }}
//           onClick={() => changeTab(PRODUCTS_TABS.FIND_SUPPLIERS)}
//         >
//           <Box mr="5px">
//             <FindSuppliersIcon
//               color={currentTab === PRODUCTS_TABS.FIND_SUPPLIERS ? "#FFFFFF" : "#5D5D5D"}
//             />
//           </Box>
//           <Box>Find Suppliers</Box>
//         </Text>
//       </Box>
//     </HStack>
//   );
// };

// const getSectorName = (s) =>
//   s?.sectorName || s?.linkedSIC2?.name || s?.sic2?.name || s?.name || null;

// // categories might be strings or objects — pick the right key safely
// const pickCategoryKey = (cat) => {
//   if (typeof cat === "string") return cat;
//   return cat?.name || cat?.categoryName || cat?.id || cat?._id || null;
// };

// const HeaderSectors = ({ currentTab, changeTab, selectedSectorData }) => {
//   const dispatch = useDispatch();

//   const {
//     categories = [],
//     categoriesLoading = false,
//     data = [],
//     loading = false,
//     loaded = false,
//   } = useSelector((s) => s.sectorSmmReducer);

//   const sectors = Array.isArray(data) ? data : [];

//   // 1) fetch categories on mount (if not present)
//   useEffect(() => {
//     if (!categoriesLoading && categories.length === 0) {
//       dispatch(getSectorCategories());
//     }
//   }, [dispatch, categoriesLoading, categories.length]);

//   // 2) after categories arrive, fetch one category’s SIC-4 list so data isn't empty
//   useEffect(() => {
//     if (!loading && sectors.length === 0 && categories.length > 0) {
//       const key = pickCategoryKey(categories[0]);
//       if (key) dispatch(getAllSectors(key));
//     }
//   }, [dispatch, loading, sectors.length, categories]);

//   // Title logic
//   const displayName = useMemo(() => {
//     // prefer selectedSectorData (from icon click)
//     const fromSelected = getSectorName(selectedSectorData);
//     if (fromSelected) return fromSelected;

//     // else fallback to first loaded SIC-4 row’s parent name/sector name
//     if (sectors.length > 0) {
//       return getSectorName(sectors[0]) || "Sector";
//     }

//     return "Sector";
//   }, [sectors, selectedSectorData]);

//   return (
//     <HStack style={{ padding: "5px 10px" }} justifyContent={"space-between"}>
//       <Box>
//         <Heading
//           fontSize="var(--sylvr-h3-fs)"
//           fontWeight="var(--sylvr-h3-fw)"
//           color="var(--sylvr-text-color)"
//           pr={3}
//         >
//           {displayName}
//         </Heading>

//         {selectedSectorData?.categoryName && (
//           <Text fontSize="sm" color="gray.600" fontStyle="italic">
//             {selectedSectorData.categoryName}
//           </Text>
//         )}

//         {loading && (
//           <Text fontSize="xs" color="gray.500">
//             Refreshing sectors…
//           </Text>
//         )}
//       </Box>

//       <HStack>
//         <SectorLinks currentTab={currentTab} changeTab={changeTab} />
//       </HStack>
//     </HStack>
//   );
// };

// export default HeaderSectors;


import { Box, Heading, HStack, Text } from "@chakra-ui/react";
import React, { useMemo, useEffect, useRef, useState } from "react";
import { PRODUCTS_TABS } from "../../constants/ui";
import CategorySizeIcon from "../../components/Icons/CategorySizeIcon";
import InsightsResearchIcon from "../../components/Icons/InsightsResearchIcon";
import SMEActivityIcon from "../../components/Icons/SMEActivityIcon";
import FindSuppliersIcon from "../../components/Icons/FindSuppliersIcon";
import { useSelector, useDispatch } from "react-redux";
import { getSectorCategories, getAllSectors } from "../../actions/sector/sectorActions";

const SectorLinks = ({ currentTab, changeTab }) => {
  const { isAuthenticatedUser } = useSelector((s) => s.userReducer || {});
  return (
    <HStack>
      <Box m="0px" w="100%">
        <Text
          className={
            currentTab === PRODUCTS_TABS.CATEGORY_SIZE
              ? "productSubTabs productSubTabs-selected"
              : "productSubTabs"
          }
          style={{ display: "flex", width: "122px" }}
          onClick={() => changeTab(PRODUCTS_TABS.CATEGORY_SIZE)}
        >
          <Box mr="5px">
            <CategorySizeIcon
              color={currentTab === PRODUCTS_TABS.CATEGORY_SIZE ? "#FFFFFF" : "#5D5D5D"}
            />
          </Box>
          <Box>Category Size</Box>
        </Text>
      </Box>

      {!isAuthenticatedUser && (
        <Box m="0px" w="100%">
          <Text
            className={
              currentTab === PRODUCTS_TABS.COMPETITIVE_RISK
                ? "productSubTabs productSubTabs-selected"
                : "productSubTabs"
            }
            style={{ display: "flex", width: "145px" }}
            onClick={() => changeTab(PRODUCTS_TABS.COMPETITIVE_RISK)}
          >
            <Box mr="5px">
              <InsightsResearchIcon
                color={currentTab === PRODUCTS_TABS.COMPETITIVE_RISK ? "#FFFFFF" : "#5D5D5D"}
              />
            </Box>
            <Box>Competitive Risk</Box>
          </Text>
        </Box>
      )}

      <Box m="0px" w="100%">
        <Text
          className={
            currentTab === PRODUCTS_TABS.SME_ACTIVITY
              ? "productSubTabs productSubTabs-selected"
              : "productSubTabs"
          }
          style={{ display: "flex", width: "122px" }}
          onClick={() => changeTab(PRODUCTS_TABS.SME_ACTIVITY)}
        >
          <Box mr="5px">
            <SMEActivityIcon
              color={currentTab === PRODUCTS_TABS.SME_ACTIVITY ? "#FFFFFF" : "#5D5D5D"}
            />
          </Box>
          <Box>SMM Activity</Box>
        </Text>
      </Box>

      <Box m="0px" w="100%">
        <Text
          className={
            currentTab === PRODUCTS_TABS.FIND_EXPERTS
              ? "productSubTabs productSubTabs-selected"
              : "productSubTabs"
          }
          style={{ display: "flex", width: "122px" }}
          onClick={() => changeTab(PRODUCTS_TABS.FIND_EXPERTS)}
        >
          <Box mr="5px">
            <SMEActivityIcon
              color={currentTab === PRODUCTS_TABS.FIND_EXPERTS ? "#FFFFFF" : "#5D5D5D"}
            />
          </Box>
          <Box>Find Experts</Box>
        </Text>
      </Box>

      <Box m="0px" w="100%">
        <Text
          className={
            currentTab === PRODUCTS_TABS.FIND_SUPPLIERS
              ? "productSubTabs productSubTabs-selected"
              : "productSubTabs"
          }
          style={{ display: "flex", width: "122px" }}
          onClick={() => changeTab(PRODUCTS_TABS.FIND_SUPPLIERS)}
        >
          <Box mr="5px">
            <FindSuppliersIcon
              color={currentTab === PRODUCTS_TABS.FIND_SUPPLIERS ? "#FFFFFF" : "#5D5D5D"}
            />
          </Box>
          <Box>Find Suppliers</Box>
        </Text>
      </Box>
    </HStack>
  );
};

const getSectorName = (s) =>
  s?.sectorName || s?.linkedSIC2?.name || s?.sic2?.name || s?.name || null;

// categories might be strings or objects — pick the right key safely
const pickCategoryKey = (cat) => {
  if (typeof cat === "string") return cat;
  return cat?.name || cat?.categoryName || cat?.id || cat?._id || null;
};

const HeaderSectors = ({ currentTab, changeTab, selectedSectorData }) => {
  const dispatch = useDispatch();

  const {
    categories = [],
    categoriesLoading = false,
    data = [],
    loading = false,
    loaded = false,
  } = useSelector((s) => s.sectorSmmReducer);

  const sectors = Array.isArray(data) ? data : [];

  // 1) fetch categories on mount (if not present)
  useEffect(() => {
    if (!categoriesLoading && categories.length === 0) {
      dispatch(getSectorCategories());
    }
  }, [dispatch, categoriesLoading, categories.length]);

  // 2) after categories FIRST arrive, fetch one category’s SIC-4 list only once
  const bootstrappedRef = useRef(false);
  const lastKeyFetchedRef = useRef(null);

  useEffect(() => {
    if (bootstrappedRef.current) return;   // run only once
    if (categories.length === 0) return;   // need categories
    if (loading) return;                   // avoid while a fetch is in-flight

    const key = pickCategoryKey(categories[0]);
    if (!key) return;
    if (lastKeyFetchedRef.current === key) return;

    dispatch(getAllSectors(key));
    lastKeyFetchedRef.current = key;
    bootstrappedRef.current = true;
  }, [dispatch, loading, categories]);

  // ---- Persist the resolved title so tabs can't blank it ----
  const [sectorTitle, setSectorTitle] = useState(null); // <-- added

  // Title logic (existing)
  const displayName = useMemo(() => {
    // prefer selectedSectorData (from icon click)
    const fromSelected = getSectorName(selectedSectorData);
    if (fromSelected) return fromSelected;

    // else fallback to first loaded SIC-4 row’s parent name/sector name
    if (sectors.length > 0) {
      return getSectorName(sectors[0]) || "Sector";
    }

    return "Sector";
  }, [sectors, selectedSectorData]);

  // Capture the first real, non-fallback title and keep it
  useEffect(() => {
    if (displayName && displayName !== "Sector") {
      setSectorTitle(displayName);
    }
  }, [displayName]);

  return (
    <HStack style={{ padding: "5px 10px" }} justifyContent={"space-between"}>
      <Box>
        <Heading
          fontSize="var(--sylvr-h3-fs)"
          fontWeight="var(--sylvr-h3-fw)"
          color="var(--sylvr-text-color)"
          pr={3}
        >
          {sectorTitle || displayName}
        </Heading>

        {selectedSectorData?.categoryName && (
          <Text fontSize="sm" color="gray.600" fontStyle="italic">
            {selectedSectorData.categoryName}
          </Text>
        )}

        {loading && (
          <Text fontSize="xs" color="gray.500">
            Refreshing sectors…
          </Text>
        )}
      </Box>

      <HStack>
        <SectorLinks currentTab={currentTab} changeTab={changeTab} />
      </HStack>
    </HStack>
  );
};

export default HeaderSectors;
